const US_CENTER = { lat: 39.8283, lng: -98.5795 };
const US_ZOOM = 10;

export { US_CENTER, US_ZOOM };
